<template>
  <t-section
    v-bind:schemaName="schemaName"
    v-bind:isCustomRow="isCustomRow"
    v-bind:defaultSort="defaultSort"
    v-bind:isHideButton="isHideButton"
    v-bind:fields="fields"
    v-bind:headers="headers"
    v-bind:addShortLabel="addShortLabel"
    v-bind:addIcon="addIcon"
    v-bind:addButtonClass="addButtonClass"
  >
    <template v-slot:toolbar-extra>
      <button
        v-if="hasMessageDialog"
        type="button"
        class="btn btn-sm btn-outline-primary section-message-button"
        v-on:click="isMessageDialogOpen = true"
      >
        <i class="fas fa-paper-plane"></i>
        <span>{{ $filters.localize("button.send") }} {{ $filters.localize("MessageDetail.caption") }}</span>
      </button>
    </template>
    <template v-slot:count="{ data }">
      <slot name="count" :data="data"></slot>
    </template>
    <template
      v-slot:body="{
        data,
        headers,
        getRowValue,
        router,
        routerOpen,
        pageCount,
      }"
    >
      <slot
        name="body"
        :data="data"
        :headers="headers"
        :getRowValue="getRowValue"
        :router="router"
        :routerOpen="routerOpen"
        :pageCount="pageCount"
      ></slot>
    </template>
    <template v-slot:buttons>
      <slot name="buttons"></slot>
    </template>
    <template
      v-if="$slots.cell"
      v-slot:cell="slotProps"
    >
      <slot
        name="cell"
        v-bind="slotProps"
      ></slot>
    </template>
  </t-section>

  <div
    v-if="isMessageDialogOpen"
    class="section-modal"
    role="dialog"
    aria-modal="true"
    v-on:click.self="isMessageDialogOpen = false"
  >
    <div class="section-modal__panel">
      <div class="section-modal__header">
        <div>
          <h2>{{ $filters.localize("button.send") }} {{ $filters.localize("MessageDetail.caption") }}</h2>
        </div>
        <button
          type="button"
          class="section-modal__close"
          v-bind:aria-label="$filters.localize('button.close')"
          v-on:click="isMessageDialogOpen = false"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="section-modal__body">
        <slot
          name="custom"
          :schemaName="schemaName"
          :close="closeMessageDialog"
        ></slot>
      </div>
    </div>
  </div>
</template>
<script>
import TSection from "@/components/Sections/Section.vue";
export default {
  name: "SectionV3",
  components: {
    TSection,
  },
  props: {
    headers: Array,
    fields: Array,
    schemaName: { type: String, required: true },
    isCustomRow: { type: Boolean },
    isHideButton: { type: Boolean },
    isHideChart: { type: Boolean },
    isHideCustom: { type: Boolean },
    defaultSort: String,
    addShortLabel: String,
    addIcon: String,
    addButtonClass: String,
  },
  data() {
    return {
      isMessageDialogOpen: false,
    };
  },
  computed: {
    hasMessageDialog: {
      get() {
        return !!this.$slots.custom && !this.isHideCustom;
      },
    },
  },
  methods: {
    closeMessageDialog() {
      this.isMessageDialogOpen = false;
    },
  },
};
</script>

